import React from 'react';
import { Icon } from 'antd';
import wandu from '../../asset/icon/wandu.svg';
import customer_srv from '../../asset/icon/customer_srv.svg';
import qq from '../../asset/icon/qq.svg';
import wechat from '../../asset/icon/wechat.svg';

export default {
    Wandu: props => <Icon component={wandu} {...props} />,
    CustomerSrv: props => <Icon component={customer_srv} {...props} />,
    QQ: props => <Icon component={qq} {...props} />,
    Wechat: props => <Icon component={wechat} {...props} />,
}



// WEBPACK FOOTER //
// ./src/component/icon/index.js